import React from "react";
import { useTranslation } from "react-i18next";
import { Text } from "vcc-ui";
import styled from "@emotion/styled";

const Container = styled.div`
    margin-top: 140px;
    text-align: center;

    h1 {
        font-size: 36px;
    }
    h3 {
        font-size: 24px;
        margin-top: 80px;
        margin-bottom: 20px;
    }
`;

export const ContactConfirm = ({email}) => {

    window.scrollTo(0, 0);
    const { t } = useTranslation();

    return (
        <Container>
            <Text as="h1" subStyle="emphasis">
                {t("ContactConfirm.header")}
            </Text>
            <Text as="h3" subStyle="emphasis">
                {t("ContactConfirm.subheader")}
            </Text>
            {<Text>
                {t("ContactConfirm.text")}&nbsp;{/*email ? email : t("ContactConfirm.fallback")*/}
            </Text>}
        </Container>
    );
};
